"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppType = exports.AppType = void 0;
var AppType;
(function (AppType) {
    AppType["GDP"] = "general-document-processor";
    AppType["Classification"] = "classification";
    AppType["DatabaseMatching"] = "database-matching";
    AppType["Legacy"] = "other";
})(AppType = exports.AppType || (exports.AppType = {}));
const getAppType = (uiSchema) => {
    switch (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema["ui:field"]) {
        case "https://widgets.super.ai/classification-table@1":
            return AppType.Classification;
        case "https://widgets.super.ai/matching-table@1":
            return AppType.DatabaseMatching;
        case "https://widgets.super.ai/document-extraction@1":
        case "https://widgets.super.ai/document-extraction-parameter@1":
            return AppType.GDP;
        default:
            return AppType.Legacy;
    }
};
exports.getAppType = getAppType;
